module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_WoodMatted_MockedUp.8d4f058a.jpg";